import { getMailboxKeyForMailboxInfo, type MailboxInfo } from 'owa-client-types';

export interface ResourceTokenAuthInfoBarRequest {
    action: string;
    mailboxInfo: MailboxInfo;
    resource: string;
    scope?: string;
    wwwAuthenticateHeader?: string;
}

export function getResourceTokenAuthInfoBarRequestKey({
    mailboxInfo,
    resource,
    scope,
    wwwAuthenticateHeader,
}: ResourceTokenAuthInfoBarRequest): string {
    return [getMailboxKeyForMailboxInfo(mailboxInfo), resource, scope, wwwAuthenticateHeader].join(
        '|'
    );
}
